import { BASE_URL, post } from "./requests"

const TRACK = `${BASE_URL}/track`

export const track = (description: string, payload?: any) => {
  post(TRACK, { description, payload })
}
